import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
});

// Inject JWT on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sf_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('sf_token');
      localStorage.removeItem('sf_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

/**
 * Download a file from an authenticated API endpoint.
 * Fetches with the JWT token and triggers a browser file download.
 */
export async function downloadFile(url, filename, extraHeaders = {}) {
  try {
    const token = localStorage.getItem('sf_token');
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}`, ...extraHeaders },
    });
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);
    const blob = await response.blob();
    const contentDisposition = response.headers.get('content-disposition');
    // Try to get filename from header
    const headerFilename = contentDisposition?.match(/filename="?([^"]+)"?/)?.[1];
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = headerFilename || filename || 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  } catch (err) {
    alert('Download failed: ' + err.message);
  }
}

export default api;
